/**
 * get a string value check for "empty string"|null|undefined if true returns "has-text-grey-lighter"
 * else return the empty string
 * @param value string value
 * @returns string value -  "empty string" | "has-text-grey-lighter"
 */
export const getEmptyOrValidClass = (value?: string | null | boolean): string => {
  return value ? '' : 'has-text-grey-lighter'
}
